import { forwardRef } from 'react';
import { Check } from 'lucide-react';

interface FeatureRowProps {
  mockupSrc: string;
  mockupAlt: string;
  title: string;
  description: string;
  bullets?: string[];
  reverse?: boolean;
  visible?: boolean;
  className?: string;
}

export const FeatureRow = forwardRef<HTMLDivElement, FeatureRowProps>(function FeatureRow(
  { mockupSrc, mockupAlt, title, description, bullets, reverse = false, visible = true, className = '' },
  ref
) {
  const rowClassName = `feature-row ${reverse ? 'feature-row-reverse' : ''} ${visible ? 'visible' : ''} ${className}`;

  return (
    <div ref={ref} className={rowClassName}>
      <div className="feature-mockup">
        <img src={mockupSrc} alt={mockupAlt} className="mockup-image" />
      </div>
      <div className="feature-text">
        <h3 className="feature-title">{title}</h3>
        <p className="feature-description">{description}</p>
        {bullets && bullets.length > 0 && (
          <ul className="feature-bullets">
            {bullets.map((bullet) => (
              <li key={bullet} className="feature-bullet">
                <Check className="feature-bullet-icon" size={16} strokeWidth={3} aria-hidden="true" />
                <span>{bullet}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
});

export default FeatureRow;


